/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseDto
 */
export interface ResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof ResponseDto
     */
    workflowInstanceId?: string;
}

/**
 * Check if a given object implements the ResponseDto interface.
 */
export function instanceOfResponseDto(value: object): boolean {
    return true;
}

export function ResponseDtoFromJSON(json: any): ResponseDto {
    return ResponseDtoFromJSONTyped(json, false);
}

export function ResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
    };
}

export function ResponseDtoToJSON(value?: ResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

